module.exports = __webpack_public_path__ + "img/20190613162124QQ截图20190612163709.b0d1eb38.png";